import React from 'react';

import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { isEqual } from 'lodash-es';
import PropTypes from 'prop-types';

import Button from '@asteria/component-core/button';
import Dropdown, { DropdownItem } from '@asteria/component-core/dropdown';
import { PageTitle } from '@asteria/component-core/pageHeader';

import * as ScenarioStore from '@asteria/datalayer/stores/scenarios';

import { useTranslate } from '@asteria/language';

const HeaderTitle = React.memo(() => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const { t } = useTranslate();

	const path = pathname.split('/').filter(Boolean);

	const scenario = useSelector(
		(store) => ScenarioStore.selectors.sourceScenarioData(store),
		isEqual,
	);

	return (
		<PageTitle
			title={t(
				['forecaster.header.title', 'forecaster.page.title'].concat(
					path.map(
						(value, index, arr) =>
							`forecaster.page.${arr
								.slice(0, index + 1)
								.join('.')}.title`,
					),
				),
				{ data: { scenario } },
			)}
		>
			{/*<Button
				variant="tertiary"
				icon="cog"
				onClick={() => {
					navigate('/forecaster/scenarios');
				}}
			/>
			<Dropdown
				toggle={{
					as: 'div',
					children: (
						<Button
							variant="tertiary"
							label="Last Edited 15 seconds ago"
						/>
					),
				}}
			>
				<DropdownItem>Changed taxes to 12 836 SEK</DropdownItem>
				<DropdownItem>Removed Salaries</DropdownItem>
				<DropdownItem>Added 1000 SEK to expenses</DropdownItem>
				<DropdownItem>
					Added 12 632 SEK to customer invoices
				</DropdownItem>
				<DropdownItem>Added 1000 SEK to expenses</DropdownItem>
				<DropdownItem>Changed taxes to 12 836 SEK</DropdownItem>
			</Dropdown>*/}
		</PageTitle>
	);
});

HeaderTitle.displayName = 'HeaderTitle';

HeaderTitle.propTypes = { className: PropTypes.string };

export default HeaderTitle;
